import React, { useEffect, useState } from 'react';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { makeStyles } from '@material-ui/core/styles';
import { PRIMARY_COLOR } from 'Config';

const useStyles = makeStyles({
    dashboardserviceicons: (props) => ({
        padding: '15px',
        width: '100%',
        borderRadius: '3px',
        '&:hover': {
            background: `${props.hoverColor} !important`,
            color: '#fff'
        }
    })
});

const OTTIcon = (props) => {
    const propsInline = { hoverColor: PRIMARY_COLOR() };

    const classesInline = useStyles(propsInline);
    const classes = commonStyle();

    const [colorNonSelected, setColorNonSelected] = useState(
        classes.svg_non_selected
    );
    const [colorSelected, setColorSelected] = useState(classes.svg_selected);

    function MouseOver(event) {
        setColorSelected(classes.svg_white);
        setColorNonSelected(classes.svg_white);
    }
    function MouseOut(event) {
        setColorSelected(classes.svg_selected);
        setColorNonSelected(classes.svg_non_selected);
    }

    return (
        <>
            <div
                className={classesInline.dashboardserviceicons}
                onMouseOver={MouseOver}
                onMouseOut={MouseOut}
            >
                <p>
                    <svg
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        viewBox="0 0 512 512"
                        style={{
                            enableBackground: 'new 0 0 512 512',
                            width: '36px'
                        }}
                    >
                        <g>
                            <path
                                className={colorNonSelected}
                                d="M478.3,253.9v53.2v104.1v74.2c0,1.4,0,2.8,0,4.1c0-0.1-0.1,1.6,0,0.4c0.1-1.3-0.3,1.2-0.3,1.2
		c0.5-1.8-0.2,0.3-0.4,0.7c-1.1,2.2,0.6-0.9-0.3,0.3c-0.3,0.4-1.7,1.4-0.2,0.4c-0.6,0.4-1.3,0.9-2,1.2c1.9-0.8-0.6,0-0.9,0.1
		c0.5-0.1,1.7-0.1-0.1-0.1c-0.2,0-0.4,0-0.6,0c-4.2,0-8.4,0-12.6,0h-65.4h-98H189.8H97.4H43.2c-1.5,0-3.1,0-4.6,0
		c-0.2,0-0.5,0-0.7,0c-0.8,0-1.4-0.2-0.1,0.1c-0.5-0.1-1-0.3-1.6-0.4c1.8,0.5-0.3-0.2-0.7-0.4c-2-1,1,1.1-0.6-0.5
		c-0.3-0.3-1-1.3-0.1,0c-0.4-0.6-0.9-1.3-1.2-2c0.9,2.2,0-2.6,0.1-0.1c-0.2-4.3,0-8.6,0-12.9v-79.2v-106v-78.9v-8.9
		c0-0.7,0-1.5,0-2.2c0-0.2,0-0.4,0-0.5v-0.1v0c0-0.3,0-0.6,0-0.8c-0.2,1-0.2,1,0.1,0c-0.1-0.1,0.7-2-0.1-0.1c0.3-0.7,0.7-1.4,1.2-2
		c-1.1,1.6,0.4-0.3,0.7-0.5c-1.1,1.1-0.4,0.2,0.1,0c0.4-0.2,2.5-0.9,0.7-0.4c0.4-0.1,2.7-0.3,0.8-0.3c0.3,0,0.7,0,1,0
		c1.7,0.1,3.5,0,5.2,0h23.2H110h69.9H283h103.5h73.1c5,0,9.9,0,14.9,0c0.3,0,0.5,0,0.8,0c1.7,0,0.5,0,0-0.1c0.4,0.1,2.5,1,0.8,0.1
		c0.4,0.2,2.2,1.6,0.7,0.3c0,0,1.7,1.8,0.9,0.8c-0.8-1,0.6,1,0.6,1c-0.9-1.7,0,0.4,0.1,0.8c-0.3-1.1,0-1-0.1,0.1
		c-0.2,4.9,0,9.8,0,14.7C478.3,228.2,478.3,241,478.3,253.9c0,4.7,4.2,9.3,9.1,9.1c4.9-0.2,9.1-4,9.1-9.1v-40.7
		c0-5.6,0.7-11.9-0.6-17.5c-2.2-9.8-11.2-16.2-21.1-16.3c-14.7-0.2-29.5,0-44.2,0h-93.1H228.7h-91.3H96.9H62.8h-22
		c-2.4,0-4.6,0-7.1,0.4c-7.9,1.3-14.4,7.2-17,14.7c-2,5.5-1.2,12.5-1.2,18.2v32.4v100.5v100.5v32.4c0,5.8-0.8,12.7,1.2,18.2
		c3.3,9.2,11.8,15,21.6,15.1c1.4,0,2.8,0,4.2,0h20.1H139h104.3h107.2h85.2c12.7,0,25.5,0.3,38.2,0c10.6-0.2,20.4-7.5,22.2-18.3
		c0.4-2.6,0.4-5.1,0.4-7.7v-27.6V358.2v-89.9v-14.4c0-4.7-4.2-9.3-9.1-9.1C482.5,245,478.3,248.8,478.3,253.9L478.3,253.9z"
                            />
                            <path
                                className={colorNonSelected}
                                d="M104.8,188.6v31.2v74.9v90.7v78.4c0,12.7-0.4,25.5,0,38.2c0,0.2,0,0.4,0,0.6c0,4.7,4.2,9.3,9.1,9.1
		c4.9-0.2,9.1-4,9.1-9.1v-31.2v-74.9v-90.7v-78.4c0-12.7,0.4-25.5,0-38.2c0-0.2,0-0.4,0-0.6c0-4.7-4.2-9.3-9.1-9.1
		C109,179.8,104.8,183.5,104.8,188.6L104.8,188.6z"
                            />
                            <path
                                className={colorNonSelected}
                                d="M76,345.6c-0.1,2.5-0.8,3.3-2.3,5.1c-1.1,1.3,1-0.3-0.6,0.5c-0.4,0.2-2.4,1.2-0.7,0.5
		c-0.8,0.3-1.5,0.4-2.3,0.7c1.6-0.5-0.2,0-0.9,0c-0.7,0-2.4-0.4-0.9,0c-0.8-0.2-1.6-0.4-2.3-0.7c1.8,0.7-0.3-0.3-0.7-0.5
		c-0.9-0.6-0.9-0.6-0.1,0c-0.3-0.3-0.6-0.5-0.9-0.8c-0.3-0.3-0.5-0.6-0.8-0.9c0.5,0.7,0.6,0.8,0.2,0.3c-0.2-0.4-1.4-2.8-0.7-1
		c-0.3-0.8-0.5-1.5-0.7-2.3c0.4,1.5,0-0.2,0-0.9c0-0.7,0.5-2.4,0-0.9c0.3-0.8,0.4-1.6,0.7-2.3c-0.7,1.8,0.3-0.3,0.5-0.7
		c0.9-1.6-0.8,0.5,0.5-0.6c0.4-0.4,0.7-0.7,1.1-1.1c-0.7,0.5-0.8,0.6-0.3,0.2c0.2-0.2,2.3-1.3,1.3-0.9c-0.9,0.4,1.3-0.4,1.6-0.4
		c0.7-0.1,0.5-0.1-0.4,0c0.6-0.1,1.1-0.1,1.7-0.1C73.1,338.9,75.9,341.9,76,345.6c0.1,4.7,4.1,9.3,9.1,9.1c4.8-0.2,9.2-4,9.1-9.1
		c-0.3-10.7-6.8-20-16.9-23.6c-9.3-3.3-20.3-0.3-26.7,7.1c-6.9,8.1-8.3,19.9-2.8,29.1c5.5,9.2,16,13.5,26.3,11.7
		c11.7-2,19.7-12.9,20-24.4c0.1-4.8-4.3-9.3-9.1-9.1C80.1,336.8,76.1,340.5,76,345.6L76,345.6z"
                            />
                            <path
                                className={colorSelected}
                                d="M258.2,389.2v-58.1v-29.8c0-0.9,0.2-2,0-2.8c0-0.1,0-0.3,0-0.4c0,0.3-0.3,1.5-0.1,0.6c0.3-1.1-0.4,0.7-0.6,0.9
		c-0.7,1.3,0.9-0.8-0.2,0.2c-0.6,0.4-0.5,0.4,0.2,0c-0.3,0.1-0.6,0.3-0.9,0.4c-1.9,0.4-1,0-0.4,0.1c-0.1,0-1.7-0.1-1.8-0.5
		c0,0,0.5,0.3,0.7,0.4c0.2,0.1,0.4,0.3,0.6,0.4c1,0.6,1.9,1.2,2.9,1.8c19.4,12.4,38.8,24.7,58.2,37.1c2.9,1.8,5.8,3.7,8.7,5.5
		c0.6,0.4,1.5,1.3,0.5,0.2c-1.1-1.1-0.4-0.6-0.1-0.1c-0.3-0.8-0.4-1.1-0.5-1.9c0.3,1.5-0.1,0.2,0.1-0.3c0.6-1.7,0.4-0.6,0.1-0.2
		c0.1-0.1,1.6-1.3,0.9-1c-2.3,0.8-4.6,2.9-6.7,4.2c-4.4,2.8-8.9,5.7-13.3,8.5c-17.1,10.9-34.4,21.4-51.3,32.6
		c-0.1,0.1-0.3,0.1-0.4,0.2c-0.9,0.6,0.7-0.2,1-0.3c1-0.3-0.6-0.5,0.4,0c0.2,0.1,2.1,1,1.1,0.3c-1.1-0.7,1.1,1.1,0.2,0.2
		c-0.8-0.7,0.4,0.7,0.5,0.9C258.6,389.6,258,386.9,258.2,389.2c-0.3-4.7-4-9.3-9.1-9.1c-4.7,0.2-9.3,4-9.1,9.1
		c0.6,12.4,13.5,20,24.5,13.5c2.5-1.5,5-3.2,7.5-4.8c10.8-6.9,21.6-13.7,32.4-20.6c9.6-6.1,19.1-12.2,28.7-18.3
		c4.5-2.9,8.6-6,10-11.6c2-7.9-2.5-14.4-8.8-18.5c-20-12.8-40.1-25.5-60.1-38.3c-3-1.9-6-3.8-9-5.7c-7.9-4.9-18.7-2.9-23.2,5.7
		c-1.9,3.8-1.8,7.6-1.8,11.7v14v71.2v1.6c0,4.7,4.2,9.3,9.1,9.1C254,398.1,258.2,394.3,258.2,389.2L258.2,389.2z"
                            />
                            <path
                                className={colorNonSelected}
                                d="M166.3,91.9c0.7-3.8,1.5-7.7,2.7-11.4c0.6-1.9,1.2-3.7,1.8-5.5c0.3-0.9,0.7-1.8,1-2.7c0.2-0.4,0.3-0.8,0.5-1.1
		c-0.7,1.6,0.1-0.2,0.2-0.5c1.6-3.5,3.3-6.9,5.3-10.1c1-1.6,2-3.2,3.1-4.8c0.5-0.8,1.1-1.6,1.6-2.3c0.2-0.3,0.5-0.7,0.7-1
		c0.9-1.2-1.3,1.6,0.3-0.4c4.7-5.9,10.1-11.2,16-16c-1.3,1.1,0.7-0.5,1.1-0.8c0.8-0.6,1.5-1.1,2.3-1.6c1.7-1.1,3.4-2.2,5.1-3.3
		c3.3-2,6.7-3.7,10.1-5.3c0.4-0.2,0.7-0.3,1.1-0.5c-1.5,0.7-0.2,0.1,0.1,0c0.9-0.4,1.8-0.7,2.7-1c1.8-0.7,3.6-1.3,5.5-1.8
		c3.9-1.2,7.8-2.1,11.8-2.8c0.4-0.1,0.8-0.1,1.3-0.2c0.3,0,2-0.3,0.9-0.1c-0.8,0.1,1.4-0.1,1.8-0.2c2.1-0.2,4.3-0.4,6.4-0.4
		c4.1-0.1,8.3,0,12.4,0.3c1,0.1,2.1,0.2,3.1,0.3c1.5,0.2-1.3-0.2,0.2,0c0.4,0.1,0.9,0.1,1.3,0.2c2.1,0.4,4.3,0.8,6.4,1.3
		c3.9,0.9,7.8,2.1,11.5,3.5c0.9,0.3,1.9,0.7,2.8,1.1c-1.4-0.6,0.9,0.4,1.3,0.6c1.9,0.9,3.8,1.8,5.7,2.8c3.5,1.9,6.8,3.9,10,6.2
		c0.9,0.6,1.8,1.3,2.7,2c-1.2-0.9,1,0.8,1.4,1.2c1.7,1.4,3.4,2.9,5,4.4c3.2,3.1,6.2,6.4,9.1,9.9c0,0.1,0.9,1.1,0.3,0.4
		c-0.5-0.7,0.5,0.6,0.6,0.8c0.7,0.9,1.3,1.8,1.9,2.7c1.3,1.9,2.5,3.7,3.6,5.7c1.1,1.9,2.2,3.9,3.2,5.9c0.5,1,1,2,1.5,3.1
		c0.2,0.4,0.3,0.8,0.5,1.2c1.1,2.6-0.6-1.6,0.4,1c1.8,4.4,6.1,8,11.2,6.3c7.5-2.5,14.5-3.9,22.1-4.1c3.2-0.1,6.4,0,9.6,0.2
		c1.4,0.1,2.8,0.2,4.1,0.4c-0.4,0-1.7-0.3,0,0c0.9,0.2,1.9,0.3,2.8,0.5c2.8,0.5,5.6,1.2,8.3,2c1.3,0.4,2.6,0.8,3.8,1.2
		c0.5,0.2,1,0.4,1.5,0.5c0.3,0.1,3.4,1.4,1.6,0.6c5.1,2.2,10,4.9,14.6,8c1.1,0.7,2.2,1.5,3.2,2.3c-1.3-1-0.2-0.2,0,0
		c0.6,0.5,1.2,1,1.8,1.5c2.2,1.9,4.3,3.8,6.3,5.9c1.8,1.9,3.5,3.9,5.2,5.9c1.6,2-0.6-0.9,0.3,0.4c0.4,0.5,0.8,1.1,1.2,1.6
		c0.9,1.3,1.8,2.6,2.7,3.9c1.4,2.2,2.7,4.5,3.9,6.9c0.6,1.2,1.2,2.4,1.7,3.6c0.1,0.2,1.1,2.7,0.3,0.8c0.3,0.7,0.6,1.5,0.9,2.2
		c2,5.4,3.4,10.9,4.3,16.5c0.5,2.7-0.2-1.9,0.1,0.9c0.1,0.8,0.2,1.7,0.3,2.5c0.1,1.7,0.2,3.4,0.3,5c0.1,4.1,0,8.3-0.5,12.4
		c-0.3,2.6-1.4,7.8-2.4,11.2c-1.1,3.8-2.5,7.6-3.9,10.6c-2.1,4.4-1.3,9.8,3.3,12.4c3.9,2.3,10.3,1.2,12.4-3.3
		c12.9-27.7,12.3-60-2.6-86.9c-12.5-22.4-34.4-39.3-59.4-45.5c-17.3-4.3-35.8-3.6-52.7,2c3.7,2.1,7.4,4.2,11.2,6.3
		c-13.6-34-43.7-60.1-80.2-66.3c-35.7-6.1-73,6-97.3,33.1c-13.2,14.7-22.4,32.9-25.8,52.5c-0.8,4.7,1.2,10,6.3,11.2
		C159.5,99.3,165.4,96.9,166.3,91.9L166.3,91.9z"
                            />
                            <path
                                className={colorNonSelected}
                                d="M72.5,184.9c-1.3-3.6-2.4-7.3-3.2-11.1c-0.8-4-1.1-7.1-1.2-11.6c0-2.9,0.1-5.8,0.4-8.7c0-0.2,0.4-3,0.1-0.9
		c0.1-0.7,0.2-1.4,0.3-2c0.3-1.8,0.7-3.5,1.1-5.2c0.7-2.6,1.4-5.2,2.4-7.8c0.3-0.8,0.6-1.5,0.9-2.3c-0.7,1.9,0.3-0.6,0.4-0.8
		c0.7-1.5,1.4-2.9,2.1-4.3c1.4-2.6,2.9-5.1,4.6-7.5c0.3-0.4,0.6-0.9,0.9-1.3c0.1-0.2,1.8-2.3,0.5-0.7c1-1.2,2-2.4,3.1-3.6
		c1.9-2.2,4-4.2,6.2-6.1c1-0.9,2-1.7,3-2.5c-1.6,1.3,0.5-0.4,0.7-0.5c0.6-0.5,1.3-0.9,1.9-1.4c2.4-1.6,4.9-3.1,7.5-4.5
		c1.2-0.6,2.4-1.2,3.6-1.8c0.2-0.1,2.7-1.1,0.8-0.4c0.9-0.3,1.7-0.7,2.6-1c2.7-1,5.4-1.8,8.2-2.4c1.3-0.3,2.7-0.6,4-0.8
		c0.8-0.1,1.6-0.3,2.4-0.4c-2.1,0.3,1.4-0.1,1.7-0.2c7.3-0.7,14.4-0.3,21.2,1.3c15.5,3.6,27.8,11.5,38,24.1c3.1,3.8,9.6,3.2,12.8,0
		c3.8-3.8,3.1-9,0-12.8c-21-26-56.9-37.1-89-27.6c-26.8,7.9-48.2,29.1-56.7,55.6c-5.5,17.4-5.1,36.8,1.2,53.9
		c1.7,4.6,6.2,7.7,11.2,6.3C70.6,194.8,74.2,189.5,72.5,184.9L72.5,184.9z"
                            />
                        </g>
                    </svg>
                </p>
                <h6>{props.name}</h6>
            </div>
        </>
    );
};

export default OTTIcon;
